import styled from 'styled-components';

import { breakpoints, SkeletonElement } from '@notino/react-styleguide-v20';

import { StyledCenteredDiv } from '@styles/generalStyles';

export const StyledWrapper = styled(StyledCenteredDiv)`
  flex-direction: column;
`;

export const StyledBarTitle = styled(SkeletonElement)`
  height: 1.5rem;
  width: 15.875rem;
  margin-bottom: 1rem;

  @media (min-width: ${breakpoints.md}) {
    width: 36.875rem;
  }
`;

export const StyledBarSubTitle = styled(SkeletonElement)`
  height: 1rem;
  width: 13.25rem;

  @media (min-width: ${breakpoints.md}) {
    width: 23.5rem;
  }
`;
